module.exports = __webpack_public_path__ + "static/media/mobile6.13f6a4c6.png";